import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MonitoringService } from '../utility/monitoring/monitoring.service';

@Injectable({
  providedIn: 'root',
})
export class NotTranslatedServiceService {
  private _webHook =
    'https://hooks.slack.com/services/TSPAWKZH9/' + environment.slackTranslateChannel;

  notFoud = '';

  constructor(private http: HttpClient, private monitoringService: MonitoringService) {}

  notTranslated(key: string) {
    let Arraykey = [];
    if (environment.enableSlack && this.notFoud !== key) {
      this.notFoud = key;
      this.sentToSlack(key);
    }
    Arraykey = key.split('.');
    if (Arraykey.length === 2) {
      return Arraykey[1].toLowerCase();
    }
    return key;
  }

  sentToSlack(key: string) {
    const message = {
      text: JSON.stringify(key),
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
    httpOptions['responseType'] = 'text';
    this.http
      .post<any>(this._webHook, message, httpOptions)
      .pipe(
        // retry(3), // retry a failed request up to 3 times
        catchError(this.monitoringService.handleError('sendSlack', null)) // then handle the error
      )
      .subscribe((data: any) => {});
  }
}
